export default __webpack_public_path__ + "images/OR.634cea4.png";